import styled from "styled-components";
export const CarouselWrapperDiv = styled.div``;
